// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://explorer.metis.io/address/0x51Ed8Fecf96813826F727CaBDF01b3cF6a61373e
export const BTC__USD = '0x51Ed8Fecf96813826F727CaBDF01b3cF6a61373e';

// https://explorer.metis.io/address/0x576855A9C189f42AcE61B784A9c049F51937f482
export const AAVE_Network_Emergency_Count_Metis = '0x576855A9C189f42AcE61B784A9c049F51937f482';

// https://explorer.metis.io/address/0xe0351cAAE70B5AdBD0107cD5331AD1D79c4c1CA1
export const DAI__USD = '0xe0351cAAE70B5AdBD0107cD5331AD1D79c4c1CA1';

// https://explorer.metis.io/address/0x54389e89A5Ec1d4312d5B5C48055d6E56a177BF9
export const AAVE__USD = '0x54389e89A5Ec1d4312d5B5C48055d6E56a177BF9';

// https://explorer.metis.io/address/0x51864b8948Aa5e35aace2BaDaF901D63418A3b9D
export const USDT__USD = '0x51864b8948Aa5e35aace2BaDaF901D63418A3b9D';

// https://explorer.metis.io/address/0xD4a5Bb03B5D66d9bf81507379302Ac2C2DFDFa6D
export const METIS__USD = '0xD4a5Bb03B5D66d9bf81507379302Ac2C2DFDFa6D';

// https://explorer.metis.io/address/0x663855969c85F3BE415807250414Ca9129533a5f
export const USDC__USD = '0x663855969c85F3BE415807250414Ca9129533a5f';

// https://explorer.metis.io/address/0x732bEa04DF4184Fb50B5648bf1A74553f01Fd850
export const sfrxETH__frxETH_Exchange_Rate = '0x732bEa04DF4184Fb50B5648bf1A74553f01Fd850';

// https://explorer.metis.io/address/0x58218ea7422255EBE94e56b504035a784b7AA204
export const L2_Sequencer_Uptime_Status_Feed = '0x58218ea7422255EBE94e56b504035a784b7AA204';

// https://explorer.metis.io/address/0x4A4F382A2FF9685de9f0418F1375cE16D0727637
export const LINK__USD = '0x4A4F382A2FF9685de9f0418F1375cE16D0727637';

// https://explorer.metis.io/address/0x3BBe70e2F96c87aEce7F67A2b0178052f62E37fE
export const ETH__USD = '0x3BBe70e2F96c87aEce7F67A2b0178052f62E37fE';

// https://explorer.metis.io/address/0x2aB80F9a26bc87c1359D86DDF89ce331648aE91E
export const frxETH__ETH_Exchange_Rate_Low = '0x2aB80F9a26bc87c1359D86DDF89ce331648aE91E';

// https://explorer.metis.io/address/0xa7CBaB1722a6631665863d624A81ab4C4eD0e876
export const frxETH__ETH_Exchange_Rate_High = '0xa7CBaB1722a6631665863d624A81ab4C4eD0e876';

export const CHAIN_ID = 1088;
